export const SkeletonLoader = ({ children, className, ...props }) => {
  return (
    <div className={["animate-pulse", className].join(" ")} {...props}>
      {children}
    </div>
  );
};
